import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import '../../assets/css/styles.css';
const axios = require('axios').default;
var config = require('../../config/config.json');


export default function StudentDashboard(props) {
  document.title = props.title;
  var retrievedUserDetailsObject = JSON.parse(localStorage.getItem('userDetailsLog'));


  const [userLoginDetails, setLoginDetailsValue] = useState(retrievedUserDetailsObject);
  const [feedbackVisibilityDetails, setFeedbackVisibilityDetails] = useState("");
  const [submittedFeedbackDetails, setSubmittedFeedbackDetails] = useState("");
  const [studentClassSemester, setStudentClassSemester] = useState(userLoginDetails.mstr_student_class_semester);
  const [currentAcademicYear, setCurrentAcademicYear] = useState(userLoginDetails.mstr_student_teacher_academic_year);
  const [courseName, setCourseName] = useState(userLoginDetails.courseName);
  // console.log('userDetailsLog: ', userLoginDetails);
  const navigate = useNavigate();

  useEffect(() => {
    getFeedbackDetails();
    getFeedbackVisibility();
    getFeedbackSubmittedStatus(userLoginDetails.mstr_student_class_semester);
  }, []);


  function clickBackToMain() {
    navigate('/StudentFeedback');
  }

  function getFeedbackDetails() {
    axios.post(config.API_URL + 'getFeedbackDetails', {
      userId: userLoginDetails.mstr_auto_id,
      userRole: userLoginDetails.role_master_auto_id,
    }, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
    }).then(function (response) {
      if (response.data.status.status == 1) {

        // console.log("User Data", response.data.data);
        setCourseName(response.data.data.courseName);
        setCurrentAcademicYear(response.data.data.mstr_student_teacher_academic_year);
        var JSONObj = {
          role_master_auto_id: response.data.data.role_master_auto_id,
          mstr_student_teacher_academic_year: response.data.data.currentAcademicYear,
          mstr_auto_id: response.data.data.mstr_auto_id,
          mstr_student_teacher_first_name: response.data.data.mstr_student_teacher_first_name,
          mstr_student__teacher_middle_name: response.data.data.mstr_student__teacher_middle_name,
          mstr_student_teacher_last_name: response.data.data.mstr_student_teacher_last_name,
          mstr_student_teacher_email: response.data.data.mstr_student_teacher_email,
          classSemester: response.data.data.classSemester,
          courseName: response.data.data.courseName,
          mstr_student_class: response.data.data.mstr_student_class,
          mstr_student_class_semester: response.data.data.mstr_student_class_semester,
          submittedFeedback: response.data.data.submittedFeedback,
          mstr_student_course: response.data.data.mstr_student_course,
          mstr_section_name: response.data.data.mstr_section_name,
          mstr_student_degree: response.data.data.mstr_student_degree,
          isAuthenticated: true,
        };
        localStorage.setItem('userDetailsLog', JSON.stringify(JSONObj));
        localStorage.setItem("isAuthenticated", true);
      }
    }).catch(function (error) {
      toast.error(error);
    });
  }

  function getFeedbackSubmittedStatus(value) {
    setStudentClassSemester(value);
    axios.post(config.API_URL + 'getSubmittedFeedbackDetails', {
      userId: userLoginDetails.mstr_auto_id,
      userRole: userLoginDetails.role_master_auto_id,
      currentAcademicYear: userLoginDetails.mstr_student_teacher_academic_year,
      classSemester: userLoginDetails.mstr_student_class_semester
    }, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
    }).then(function (response) {
      if (response.data.status.status == 1) {
        if (response.data.data != null && response.data.data != "") {
          setSubmittedFeedbackDetails(response.data.data);
        } else {
          setSubmittedFeedbackDetails("");
        }
      }
    }).catch(function (error) {
      toast.error(error);
    });
  }

  function getFeedbackVisibility() {
    axios.post(config.API_URL + 'getFeedbackVisibilityDetails', {
      userRole: userLoginDetails.role_master_auto_id
    }, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
    }).then(function (response) {
      if (response.data.status.status == 1) {
        if (response.data.data != null && response.data.data != "") {
          setFeedbackVisibilityDetails(response.data.data);
        } else {
          setFeedbackVisibilityDetails("");
        }
      }
    }).catch(function (error) {
      toast.error(error);
    });
  }

  function onFeedbackSelectSubmitClick(feedbackLink) {
    // console.log(feedbackLink);
    localStorage.setItem("selectedStudentClassSemester", studentClassSemester);
    navigate(feedbackLink);
  }

  function clickOnLogOut() {
    localStorage.removeItem("userDetailsLog");
    localStorage.removeItem("isAuthenticated");
    localStorage.clear();
    navigate('/Student');
  }

  const LogoURL = require(`../../assets/images/${config.logoUrl}`).default;
  return (
    <div className="index-cover">
      <div className="container main-container">
        <section className='section-header' >
          <div className='row'><div className="col-md-12" >
            <div className='logout-strip'>
              <div className='link-holder'>
                <a className="btn-link" type="button">Welcome {userLoginDetails.mstr_student_teacher_first_name}&nbsp;{userLoginDetails.mstr_student_teacher_last_name}&nbsp;[&nbsp;{courseName}&nbsp;]</a>
                <span className='line-divider'></span>
                <a className="btn-link" type="button" onClick={clickOnLogOut}>Logout</a>
              </div>
            </div>
            <div className="college-name" ><img src={LogoURL} className='logo-college' alt='' />{config.collegeName} </div>
            <div className='feedback-title' >Student Dashboard</div>
          </div>
          </div>
        </section>

        <section className='section-userInformation'>
          <div className='feedbackFor'><a href='#' className='backToMain' onClick={clickBackToMain}><i className='fa fa-arrow-left'
            style={{ marginRight: '5px' }}></i>Back to Main Page</a><span
              className='divider'>|</span><strong>Year:</strong>{userLoginDetails.mstr_student_teacher_academic_year}<span className='divider'>|</span><strong>
              Semester:</strong>{studentClassSemester} <span className='divider'>|</span> <strong>Program:</strong> {courseName}
            <span className='divider'>|</span> <strong>Section:</strong> {userLoginDetails.mstr_section_name}
          </div>
          <div className='row'>
            <div className='col-md-12'>
              <div className='note note-thankyou'>
                <span style={{ display: 'block', marginBottom: '10px', }}>Dear {userLoginDetails.mstr_student_teacher_first_name} {userLoginDetails.mstr_student_teacher_last_name},  </span>We would greatly appreciate your feedback about the college. This will help us to strengthen the college programmes and infrastructure. We request to read the questions carefully answer Your identity and responses will be kept confidential. </div>
            </div>
          </div>
          {/* <div className='row'>
            <div className="form-group col-md-4">
              <label htmlFor="name">Program  <em>*</em></label>
              <select className="form-control" disabled>
                <option value={userLoginDetails.courseName}>{userLoginDetails.courseName}</option>
              </select>

            </div>
            <div className="form-group col-md-4">
              <label>Semester currently studying in  <em>*</em></label>
              <select className="form-control" disabled onChange={(e) => getFeedbackSubmittedStatus(e.target.value)} value={studentClassSemester}>
                {
                  userLoginDetails.classSemester.split(',').map((val) => (
                    <option value={val}>{val}</option>
                  ))
                }
              </select>
            </div>
          </div> */}

          <div className='row'>
            <div className='row-feedbackbox '>

              {
                feedbackVisibilityDetails.split(',').includes('Infrastructure') == true ?
                  (submittedFeedbackDetails.split(',').includes('Infrastructure') == false ?
                    <div className="col-md-4">
                      <div className='box-feedback' >
                        <span className='number'>1</span><h4><span> Feedback on </span>Infrastructure  </h4>
                        <button className='btn btn-primary' onClick={() => onFeedbackSelectSubmitClick('/StudentInfrastructureFeedback')} ref={(el) => { if (el) { el.style.setProperty('background-color', 'rgb(66, 139, 202)', 'important'); } }} >Start Feedback</button>
                      </div>
                    </div>
                    :
                    <div className="col-md-4">
                      <div className="box-feedback submitted">
                        <span className='status'>Submitted</span>
                        <h4> <span>Feedback on </span>Infrastructure</h4>
                        <button className="btn btn-primary btn-block" ref={(el) => { if (el) { el.style.setProperty('color', '#FFFFFF', 'important'); el.style.setProperty('cursor', 'default', 'important'); } }}>Submitted</button>
                      </div>
                    </div>
                  )
                  : null
              }

              {
                feedbackVisibilityDetails.split(',').includes('Course Transaction') == true ?
                  (submittedFeedbackDetails.split(',').includes('Course Transaction') == false ?
                    <div className='col-md-4'>
                      <div className='box-feedback'>
                        <span className='number'>2</span><h4> <span>Feedback on </span>Course Transaction</h4>
                        <button className='btn btn-primary btn-block' ref={(el) => { if (el) { el.style.setProperty('background-color', 'rgb(66, 139, 202)', 'important'); } }} onClick={() => onFeedbackSelectSubmitClick('/CourseTransactionFeedback')}>Start Feedback</button>
                      </div>
                    </div>
                    :
                    <div className="col-md-4">
                      <div className="box-feedback submitted">
                        <span className='status'>Submitted</span>
                        <h4> <span>Feedback on </span>Course Transaction</h4>
                        <button className="btn btn-primary btn-block" ref={(el) => { if (el) { el.style.setProperty('color', '#FFFFFF', 'important'); el.style.setProperty('cursor', 'default', 'important'); } }}>Submitted</button>
                      </div>
                    </div>
                  )
                  : null
              }

              {
                feedbackVisibilityDetails.split(',').includes('SSS') == true ?
                  (submittedFeedbackDetails.split(',').includes('SSS') == false ?
                    <div className='col-md-4'>
                      <div className='box-feedback'>
                        <span className='number'>3</span><h4> <span>SSS</span>Student Satisfaction Survey</h4>
                        <button className='btn btn-primary btn-block' ref={(el) => { if (el) { el.style.setProperty('background-color', 'rgb(66, 139, 202)', 'important'); } }} onClick={() => onFeedbackSelectSubmitClick('/SSSFeedback')}>Start Feedback</button>
                      </div>
                    </div>
                    :
                    <div className="col-md-4">
                      <div className="box-feedback submitted">
                        <span className='status'>Submitted</span>
                        <h4> <span>Feedback on </span>Student Satisfaction Survey</h4>
                        <button className="btn btn-primary btn-block" ref={(el) => { if (el) { el.style.setProperty('color', '#FFFFFF', 'important'); el.style.setProperty('cursor', 'default', 'important'); } }}>Submitted</button>
                      </div>
                    </div>
                  )
                  : null
              }

            </div>
          </div>
        </section>
        <section className='section-footer'>
          <div className='row'>
            <div className='footer'>
              <div className='col-md-6 col-sm-6' >{config.collegeName}, Feedback System {config.version}</div>
              <div className='col-md-6 col-sm-6 text-poweredBy'>{config.PoweredBy}</div>
            </div>
          </div>
        </section>
      </div>
      <ToastContainer />
    </div>
  )
}